import { useFlags } from "launchdarkly-react-client-sdk"

export function useRecommendationsEnabledJourneys(): string[] {
  const { carrotPlanRecommendationsOverride } = useFlags() as {
    carrotPlanRecommendationsOverride?: { journeys?: string[] }
  }
  return carrotPlanRecommendationsOverride?.journeys ?? []
}

export function useRecommendationsEnabledForJourney(journey: string | undefined): boolean {
  const enabledJourneys = useRecommendationsEnabledJourneys()
  return journey != null && enabledJourneys.includes(journey)
}
